export default class Upload {
    public id!: string;
    public commited!: boolean;
    public iv!: string; // This is base64 encoded
    public encryptedMetadata!: string; // This is base64 encoded
    public passwordProtected!: boolean;
    public secretEncrypted!: string;
    public secretEncryptedIv!: string;
    public created!: number;
    public expiry!: Date;

    public toString(): string {
        return JSON.stringify(this);
    }

    public static fromString(json: string): Upload {
        const newInstance = new Upload();
        const restored = JSON.parse(json);
        return Object.assign(newInstance, restored);
    }
}
